import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'gatsby';
import Icon from 'shared/icon';
import styles from './accordeon.module.scss';

function Accordeon({ items, handleNav }) {
  const collapsable = useRef(null);
  const [open, toggleOpen] = useState(false);
  const [height, setHeight] = useState(0);
  useEffect(() => {
    if (open && collapsable) {
      setHeight(collapsable.current.scrollHeight);
      collapsable.current.style.height = `${collapsable.current.scrollHeight}px`;
    } else if (collapsable) {
      collapsable.current.style.height = '0';
    }
  }, [height, open]);

  function heightChange(open) {
    if (open) {
      collapsable.current.style.height = `${height}px`;
    } else {
      collapsable.current.style.height = 0;
    }
  }
  return (
    <>
      <div
        className={styles.toggleBtn}
        onClick={() => {
          toggleOpen(!open);
          heightChange(!open);
        }}
      >
        <Icon icon={open ? 'minus' : 'plus'} />
      </div>
      <ul className={styles.accordeon} ref={collapsable}>
        {items.map(item => (
          <li key={item.link}>
            <Link
              to={`/${item.link}`}
              onClick={() => {
                if (window.innerWidth <= 1229) {
                  handleNav();
                }
              }}
            >
              <span dangerouslySetInnerHTML={{ __html: item.name }} />
            </Link>
          </li>
        ))}
      </ul>
    </>
  );
}
export default Accordeon;
